import { styled } from '@mui/material'

const Main = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.rsmBackground.main,
  paddingTop: '2.5rem',
  paddingBottom: '2.5rem',
}))

export default Main
